import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import {useTranslation} from 'react-i18next'

// Renders the exact HTML the backend would send (same renderEmailTemplate call as the real
// send path) inside a sandboxed iframe — no scripts, no access to the app's own styles/DOM,
// so it's safe to show untrusted rich-text-derived markup and it looks like a real inbox preview.
const EmailPreviewDialog = ({open, onClose, html}) => {
    const {t} = useTranslation()

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth aria-labelledby="email-preview-dialog">
            <DialogTitle>
                {t('send_email.previewTitle')}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{position: 'absolute', right: 8, top: 8}}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{p: 0, bgcolor: '#f5f7fa'}}>
                <iframe
                    srcDoc={html || ''}
                    sandbox=""
                    title="email-preview"
                    style={{width: '100%', height: '70vh', border: 'none', display: 'block'}}
                />
            </DialogContent>
        </Dialog>
    )
}

export default EmailPreviewDialog
